type ProjectConfiguration = {
  isSynthesisEnabled: boolean;
  isListsListEnabled: boolean;
  isBoardEnabled: boolean;
  isGanttEnabled: boolean;
  areTimeSheetsEnabled: boolean;
  areDiscussionsEnabled: boolean;
  areDocumentsEnabled: boolean;
  isBudgetEnabled: boolean;
  isCalendarEnabled: boolean;
  areReportsEnabled: boolean;
};

const projectConfiguration: ProjectConfiguration = {
  isBoardEnabled: true,
  isGanttEnabled: true,
  isListsListEnabled: true,
  isSynthesisEnabled: true,
  areTimeSheetsEnabled: true,
  areDiscussionsEnabled: true,
  areDocumentsEnabled: true,
  isBudgetEnabled: true,
  isCalendarEnabled: true,
  areReportsEnabled: true,
};

export type { ProjectConfiguration };

export { projectConfiguration };
